import { render, staticRenderFns } from "./proDelStart.vue?vue&type=template&id=11de8879&scoped=true&"
import script from "./proDelStart.vue?vue&type=script&lang=js&"
export * from "./proDelStart.vue?vue&type=script&lang=js&"
import style0 from "./proDelStart.vue?vue&type=style&index=0&id=11de8879&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11de8879",
  null
  
)

export default component.exports